/// <reference path="./custom-window.d.ts" />

window.PLSearchInstall = function (id) {
  const container = document.getElementById(id) as HTMLElement;
  const dropDown = container.querySelector('#' + id + '-dropdown') as HTMLElement;

  document.addEventListener('click', (event) => {
    if (dropDown !== null && event.target instanceof Node && !dropDown.contains(event.target)) {
      dropDown.classList.remove('show');
    }
  });
}

console.log('PLSearch has been installed');